import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, Fragment as _Fragment, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-504cc548")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_BusinessModelDetailsCard = _resolveComponent("BusinessModelDetailsCard")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_MetadataCard = _resolveComponent("MetadataCard")
  const _component_BusinessModelVersionsCard = _resolveComponent("BusinessModelVersionsCard")
  const _component_Badge = _resolveComponent("Badge")
  const _component_BusinessModelDriversCard = _resolveComponent("BusinessModelDriversCard")
  const _component_TabView = _resolveComponent("TabView")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-m-0" }, {
      start: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.selectedBusinessModel.name), 1)
      ]),
      end: _withId(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: _ctx.buttonDisabled,
          onClick: _ctx.handleSubmit,
          "data-test": "submit-button"
        }, null, 8, ["disabled", "onClick"]),
        _createVNode(_component_Button, {
          icon: "pi pi-times",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.closeTemplate,
          "data-test": "close-button"
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar"
        }))
      : (_openBlock(), _createBlock(_component_TabView, {
          key: 1,
          class: "tabview-custom kn-page-content"
        }, {
          default: _withId(() => [
            _createVNode(_component_TabPanel, null, {
              header: _withId(() => [
                _createVNode("span", null, _toDisplayString(_ctx.$t('managers.businessModelManager.details')), 1)
              ]),
              default: _withId(() => [
                _createVNode(_component_BusinessModelDetailsCard, {
                  selectedBusinessModel: _ctx.selectedBusinessModel,
                  domainCategories: _ctx.categories,
                  datasourcesMeta: _ctx.datasources,
                  user: _ctx.user,
                  toGenerate: _ctx.toGenerate,
                  readonly: _ctx.readonly,
                  businessModelVersions: _ctx.businessModelVersions,
                  onFieldChanged: _ctx.onFieldChange,
                  onFileUploaded: _cache[1] || (_cache[1] = ($event: any) => (_ctx.uploadedFile = $event)),
                  onDatamartGenerated: _ctx.loadPage,
                  onModelGenerated: _ctx.loadVersions
                }, null, 8, ["selectedBusinessModel", "domainCategories", "datasourcesMeta", "user", "toGenerate", "readonly", "businessModelVersions", "onFieldChanged", "onDatamartGenerated", "onModelGenerated"])
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, null, {
              header: _withId(() => [
                _createVNode("span", null, _toDisplayString(_ctx.$t('managers.businessModelManager.metadata')), 1)
              ]),
              default: _withId(() => [
                (_ctx.businessModelVersions.length > 0 && !_ctx.readonly)
                  ? (_openBlock(), _createBlock(_component_MetadataCard, {
                      key: 0,
                      id: _ctx.selectedBusinessModel.id
                    }, null, 8, ["id"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, null, {
              header: _withId(() => [
                _createVNode("span", null, _toDisplayString(_ctx.$t('managers.businessModelManager.savedVersions')), 1)
              ]),
              default: _withId(() => [
                _createVNode(_component_BusinessModelVersionsCard, {
                  id: _ctx.selectedBusinessModel.id,
                  versions: _ctx.businessModelVersions,
                  readonly: _ctx.readonly,
                  onTouched: _ctx.setDirty,
                  onDeleted: _ctx.loadVersions
                }, null, 8, ["id", "versions", "readonly", "onTouched", "onDeleted"])
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, null, _createSlots({
              default: _withId(() => [
                (_ctx.id)
                  ? (_openBlock(), _createBlock(_component_BusinessModelDriversCard, {
                      key: 0,
                      id: _ctx.selectedBusinessModel.id,
                      drivers: _ctx.drivers,
                      driversOptions: _ctx.analyticalDrivers,
                      readonly: _ctx.readonly,
                      onDelete: _ctx.setDriversForDelete
                    }, null, 8, ["id", "drivers", "driversOptions", "readonly", "onDelete"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, [
              (_ctx.id)
                ? {
                    name: "header",
                    fn: _withId(() => [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('managers.businessModelManager.drivers')), 1),
                      (_ctx.invalidDrivers > 0)
                        ? (_openBlock(), _createBlock(_component_Badge, {
                            key: 0,
                            value: _ctx.invalidDrivers,
                            class: "p-ml-2",
                            severity: "danger"
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true)
                    ])
                  }
                : undefined
            ]), 1024)
          ]),
          _: 1
        }))
  ], 64))
})